<!--
    Notification button with dropdown menu (Feature component)

    <NotificationSkeleton />
-->
<script setup lang="ts">
import { AfSkeleton } from '@af-lib/ui-lib';
</script>

<template>
  <v-sheet v-for="n in 3" :key="n" class="d-flex align-center pa-4 notification-skeleton-container" minWidth="428">
    <AfSkeleton class="flex-shrink-0" :type="'circle-s'" />
    <div class="d-flex flex-column w-100 notification-skeleton-lines">
      <AfSkeleton :type="'line-xs'" />
      <AfSkeleton class="w-50" :type="'line-xs'" />
    </div>
  </v-sheet>
</template>

<style scoped lang="scss">
.notification-skeleton-container {
  gap: 18px;
}
.notification-skeleton-lines {
  gap: 16px;
}
</style>
